import React from 'react';
import PropTypes from 'prop-types';
import FilterBySelectInput from 'components/FilterBySelectInput';
import { SOURCE_FILTER_OPTIONS } from 'screens/ProductList/helpers/tableConstants';

const ProductListSourceFilter = ({ sourceFilters, handleFilterChange }) => {
  return (
    <div className="w-220px ml-4 font-medium max-h-8 whitespace-nowrap">
      <FilterBySelectInput
        selectDataTestId="product-source-filter"
        options={SOURCE_FILTER_OPTIONS}
        value={sourceFilters}
        onChange={handleFilterChange}
        placeholder="Filter by source"
      />
    </div>
  );
};

ProductListSourceFilter.propTypes = {
  sourceFilters: PropTypes.arrayOf(PropTypes.string).isRequired,
  handleFilterChange: PropTypes.func.isRequired
};
export default ProductListSourceFilter;
